import { AxiosService } from './axios.service'

const baseURL = 'recusas'

/**
 * Defines the API methods for managing ticket denials.
 */
export class DenialService {
	 /**
     * Retrieves a denial by its ID.
     * @param {string} denialId - The ID of the denial.
     * @return {Promise<Blob>} A promise that resolves to the blob data of the specified denial.
     */
	static getDenialById(denialId) {
		return AxiosService.get(
			`${baseURL}/${denialId}`,{ responseType: 'blob' }
		).then(({ data }) => data)
	}
}

export default DenialService
